const API_SUBDOMAIN = 'booking'

const isDev = process.env.NODE_ENV !== 'production'
const isProd = process.env.NODE_ENV === 'production'

module.exports = {
    isDev: isDev,
    isProd: isProd,
    contacts: {
        email: 'info@skiesarebusiness.com',
        phone: '+1 (844) 984-6076',
        customer_support_phone: '+1 (844) 411-6066',
        address: '2200 S Main St Office 207 Lombard, IL 60148, USA, Skies Are Business',
    },
    api: {
        base() {
            return location.protocol + '//' + API_SUBDOMAIN + '.' + location.hostname + '/'
        },
    },
    analytics: {
        google_tag_manager: {
            enabled: process.env.ENABLE_ANALYTICS || isProd,
            id: isProd ? 'GTM-KZZ8MG4' : 'GTM-PKNX9VD',
            queryParams: {},
        },
    },
}



//////////////////
// WEBPACK FOOTER
// ./app.config.js
// module id = RGMo
// module chunks = 1 2 3